import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class ShadeGroupSelectedUseCase {
    private eventRepository: EventRepository;
    private shadeGroupKey: string;
    private eventName: string;
    private eventAction: string;

    constructor(shadeGroupKey: string, eventName: string, eventAction: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.shadeGroupKey = shadeGroupKey;
        this.eventName = eventName;
        this.eventAction = eventAction;
    }

    public execute = () => {
        const payload = {
            event_name: this.eventName,
            event_category: 'filter & sort selection ',
            event_action: this.eventAction,
            event_label: this.shadeGroupKey
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.PRODUCT_SHADE_GROUP_SELECTED,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
